module.exports = __webpack_public_path__ + "static/media/bartek.ac800bae.jpg";